module.exports = __webpack_public_path__ + "static/img/direction.b4d583f8.png";